<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        span="Spinning"
        block
        v-if="loadingSpinner"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>

    <section class="invoice-preview-wrapper" v-if="!loadingSpinner">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="8">
          <b-card
            no-body
            class="invoice-preview-card"
            id="invoice-preview-card"
            style="display: block; width: 100%"
          >
            <b-card-body class="invoice-padding pb-0">
              <div class="row align-items-center mb-2">
                <div class="col-md-1 col-1">
                  <Logo />
                </div>
                <div class="col-9">
                  <div class="">
                    <CompanyName />
                  </div>
                  <div class="">
                    <Address />
                  </div>
                </div>
              </div>

              <b-card-body class="invoice-padding pt-0">
                <div class="row">
                  <div class="col-6">
                    <div class="invoice-spacing">
                      <div>
                        <h6 class="mb-2">Supplier</h6>
                        <CompanyAddress :supplier="supplierId" />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="invoice-number-date mt-md-0 mt-2">
                  <div
                    class="d-flex align-items-center justify-content-md-end mb-1"
                  >
                    <h4>
                      Purchase Invoice #{{ purchaseinvoiceId.orderNumber }}
                    </h4>
                  </div>
                  <div class="d-flex align-items-center my-2">
                    <span class="title"> Issued Date: </span>
                    <flat-pickr
                      v-model="purchaseinvoiceId.issueDate"
                      class="form-control invoice-edit-input"
                      disabled
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title"> Due Date: </span>
                    <flat-pickr
                      v-model="purchaseinvoiceId.dueDate"
                      class="form-control invoice-edit-input"
                      disabled
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title"> Supplier Reference: </span>
                    <input
                      v-model="purchaseinvoiceId.supplierReference"
                      type="text"
                      class="form-control invoice-edit-input"
                      disabled
                    />
                  </div>

                  <div v-if="this.vat" class="d-flex align-items-center my-2">
  <span class="title me-2">VAT:</span>
  <p class="invoice-date mb-0">{{ this.vat }}</p>
</div>

                  <div v-if="this.vat" class="d-flex align-items-center my-2">
  <span class="title me-2">BRN Number:</span>
  <p class="invoice-date mb-0">{{ this.brn }}</p>
</div>
                </div>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                >
                  <!-- Header: Right Content -->
                </div>
              </b-card-body>





            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />


            <b-card-body class="invoice-padding pb-0">
              <!-- Invoice Description: Table -->
              <b-table
                responsive
                :fields="fields"
                :items="purchaseinvoiceId.purchaseInvoiceItems"
              >
                <template #cell(itemId)="data">
                  {{ getItemName(data.item.itemId) }}
                </template>
                <template #cell(cost)="data">
                  Rs {{ data.item.cost.toFixed(2) }}
                </template>

                <template #cell(qty)="data">
                {{ parseFloat(data.item.quantity).toFixed(2) }}
              </template>

              <template #cell(VAT)="data">
                {{  data.item.saleTaxPercentage ? parseFloat(data.item.saleTaxPercentage).toFixed(2) : 0 }} %
              </template>

              


                <template #cell(price)="data">
                  Rs {{ (data.item.cost * data.item.quantity).toFixed(2) }}
                </template>
              </b-table>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3"
                  order="2"
                  order-md="1"
                >
                  <b-card-text class="mb-0">
                    <span class="font-weight-bold">Salesperson :</span>
                    <span class="ml-75"
                      >{{salesPersonName }}
                    </span>
                  </b-card-text>
                </b-col>

                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <hr class="my-50" />

                    <div class="invoice-total-item">
                      <p class="invoice-total-title">SubTotal:</p>
                      <p class="invoice-total-amount">
                        Rs {{ purchaseinvoiceId.subTotal.toFixed(2) }}
                      </p>
                    </div>
                    <div class="invoice-total-item"  v-if="vat">
                      <p class="invoice-total-title">VAT:</p>
                      <p class="invoice-total-amount">
                        Rs {{ purchaseinvoiceId.tax.toFixed(2) }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Total:</p>
                      <p class="invoice-total-amount">
                        Rs {{ purchaseinvoiceId.total.toFixed(2) }}
                      </p>
                    </div>

                   
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Note: </span>
              <span>{{ purchaseinvoiceId.note }}</span>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Col: Card -->
        <b-col cols="12" md="4" xl="3" class="invoice-actions">
          <b-card>
            <!-- Button: DOwnload -->

            <!-- Button: Print -->
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="printQuotation"
            >
              Print / Download
            </b-button>
            <b-button
              v-if="supplierId.phoneNumber && tenant"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="info"
              class="mb-75"
              @click="openWhatsApp"
              block
            >
              <img src="@/assets/images/logo/whatsapp.png" class="w-10" />
              Whatsapp
            </b-button>

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="viewPurchaseInvoiceDocuments(purchaseinvoiceId)"
            >
              Documents
            </b-button>

            <b-button
            v-if="purchaseinvoiceId.status === 0"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="completePurchaseInvoice(purchaseinvoiceId)"
          >
            Complete
          </b-button>

      <b-modal ref="modal-view-purchase-invoice-document" id="modal-view-purchase-invoice-document" ok-only
        ok-title="View" centered size="lg" title="View Purchase Invoice Documents" :hide-footer="true">
        <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
          :documentDetails="documentDetails" />
      </b-modal>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BLink,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { deletePurchaseInvoiceDocument, uploadPurchaseInvoiceMultipleDocuments, uploadPurchaseInvoiceDocument, downloadPurchaseInvoiceDocument } from '@/store/purchaseinvoice/services';
import { customSwal, customError } from '@/libs/customFn';
import { mapActions, mapGetters } from "vuex";
import purchaseinvoice from "@/store/purchaseinvoice";
import CompanyAddress from "@/@core/layouts/components/CompanyAddress.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import Address from "@core/layouts/components/Address.vue";


export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    flatPickr,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    VBToggle,
    BFormSelect,
    Logo,
    BSpinner,
    BTable,
    BLink,
    DocumentUpload,
    CompanyAddress,
    CompanyName,
    Address
  },
  data() {
    return {
      id: this.$route.params.id,
      loadingSpinner: false,
      tenant: localStorage.getItem("userTenant"),
      companyName: localStorage.getItem("userTenant"),
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      brn: JSON.parse(localStorage.getItem("userData")).brn,
      leadClientId: "",
      salesPersonId: "",
      salesPersonName: "",
      dueDate: "",
      subTotal: "",
      discount: "",
      tax: "",
      total: "",
      notes: "",
      status: "",
      supplierReference: "",
      paymentMethod: "",
      quotationItems: {
        id: "",
        purchaseinvoiceId: "",
        itemId: "",
        quantity: "",
        price: "",
        cost: "",
        isActive: "",
      },

      fields: [
        { key: "id", span: "ID", thClass: "d-none", tdClass: "d-none" }, //thClass and tdClass used to hide fields
        {
          key: "purchaseinvoiceId",
          span: "QUOTATION_ID",
          thClass: "d-none",
          tdClass: "d-none",
        },
        { key: "itemId", span: "Item Name" },
        { key: "cost", span: "Unit Price (Rs)" },
        { key: "quantity", span: "QUANTITY" },

        { key: "price", span: "Total Price (Rs)" },
      ],
      warehouseName: "",
      documentDetails: {
        isDelete: false,
        documentList: []
      },
    };
  },
  computed: {
    ...mapGetters("purchaseInvoiceModule", {
      purchaseinvoiceId: "purchaseinvoiceId",
      documentsInvoice: "documents",
      loading: "loading",
    }),
    
    ...mapGetters("purchaseOrderModule", {
      loading: "loading",
      documentsOrder: "documents",
      file: "file",
    }),
    ...mapGetters("supplierModule", {
      supplierId: "supplierId",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      productList: "product",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      materials: "rawmaterials",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
  },
  methods: {
    ...mapActions("purchaseInvoiceModule", ["updatePurchaseInvoicesAction"]),
    async completePurchaseInvoice(purchaseInvoiceId) {
    try {
        const confirm = await this.$swal({
            title: "Are you sure?",
            text: "This will mark the invoice as completed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Complete",
            cancelButtonText: "Cancel",
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
        });

        if (!confirm.isConfirmed) return; 

        this.$swal({
            title: "Processing...",
            text: "Please wait while the invoice is being marked as complete...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                this.$swal.showLoading();
            },
        });

        let clonedInvoice = JSON.parse(JSON.stringify(purchaseInvoiceId));

        let payload = {
            id: clonedInvoice?.id,
            status: 1,
            supplierReference: clonedInvoice?.supplierReference,
            supplierId: clonedInvoice?.supplierId,
            quantity: clonedInvoice?.quantity,
            totalCost: clonedInvoice?.totalCost,
            issueDate: clonedInvoice?.issueDate,
            balance: clonedInvoice?.balance,
            salesPersonId: clonedInvoice?.salesPersonId,
            paymentMethod: clonedInvoice?.paymentMethod,
            dueDate: clonedInvoice?.dueDate,
            orderNumber: clonedInvoice?.orderNumber,
            subTotal: clonedInvoice?.subTotal,
            discount: clonedInvoice?.discount,
            tax: clonedInvoice?.tax,
            total: clonedInvoice?.total,
            note: clonedInvoice?.note,
            warehouseId: clonedInvoice?.warehouseId,
            purchaseInvoiceItems: clonedInvoice?.purchaseInvoiceItems?.map(item => ({
                id: item?.id,
                itemId: item?.itemId,
                quantity: item?.quantity,
                cost: item?.cost,
                saleTaxPercentage: item?.saleTaxPercentage
            })),
        };

        console.log("🔍 Payload being sent:", payload);

        this.updatePurchaseInvoicesAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Purchase Order Completed",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getPurchaseInvoicesByIDAction(this.id);
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Purchase Order Not Cancelled",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        });
    } catch (error) {
        console.error("❌ Error completing invoice:", error);

        this.$swal({
            title: "Error!",
            text: error.response?.data?.message || error.message || "Failed to complete the invoice.",
            icon: "error",
            customClass: {
                confirmButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });
    }
},
      async viewPurchaseInvoiceDocuments(purchaseInvoice) {
      try {
        if(purchaseInvoice.purchaseOrderId == null && this.purchaseinvoiceId.id == null) {
          //this.PInvoiceId = '';
          this.documentDetails.documentList = [];
          this.$refs["modal-view-purchase-invoice-document"].show();
        }
        else if (purchaseInvoice.purchaseOrderId == null){
          this.PInvoiceId = this.purchaseinvoiceId.id
          await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
       // await this.getPurchaseOrderDocumentListAction(this.PInvoiceId);
        this.documentDetails.documentList = [];
        const purchaseInvoiceDocuments = this.documentsInvoice || [];
       // const purchaseOrderDocuments = this.documentsOrder || [];
        //console.log("👉 purchaseInvoiceDocuments", purchaseInvoiceDocuments);
        //console.log("👉 purchaseOrderDocuments", purchaseOrderDocuments);
        // Merge both document lists
        if (this.documentsInvoice.length > 0) {
          //this.documentDetails.documentList = [...purchaseInvoiceDocuments, ...purchaseOrderDocuments];
          this.documentDetails.documentList = [
  ...(this.documentsInvoice || [])
];
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-invoice-document"].show();
        }
        else {
          
          this.PInvoiceId = purchaseInvoice.purchaseOrderId;
       
        
        // console.log('referenceId', purchaseInvoice.purchaseOrderId);
        // console.log('PInvoiceId', this.PInvoiceId);
        await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
        await this.getPurchaseOrderDocumentListAction(this.PInvoiceId);
        this.documentDetails.documentList = [];
        const purchaseInvoiceDocuments = this.documentsInvoice || [];
        const purchaseOrderDocuments = this.documentsOrder || [];
        console.log("👉 purchaseInvoiceDocuments", purchaseInvoiceDocuments);
        console.log("👉 purchaseOrderDocuments", purchaseOrderDocuments);
        // Merge both document lists
        if (this.documentsInvoice.length > 0 || this.documentsOrder.length > 0) {
          //this.documentDetails.documentList = [...purchaseInvoiceDocuments, ...purchaseOrderDocuments];
          this.documentDetails.documentList = [
  ...(this.documentsInvoice || []),
  ...(this.documentsOrder || [])
];
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-invoice-document"].show();
      }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadPurchaseInvoiceDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document(s) is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      let referenceId = null;
      if(this.PInvoiceId == null){
        console.log("this.purchaseinvoiceId.id", this.purchaseinvoiceId.id);
referenceId = this.purchaseinvoiceId.id;
      }
      else{
         referenceId = this.PInvoiceId;
      }
      

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {

        await uploadPurchaseInvoiceMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            this.$refs["modal-view-purchase-invoice-document"].hide();
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadPurchaseInvoiceDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            this.$refs["modal-view-purchase-invoice-document"].hide();
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getPurchaseInvoiceDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-order-document');
      });
    },
    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being deleted',
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deletePurchaseInvoiceDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
         this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-invoice-document');
      });
    },

    printQuotation() {
      window.print();
    },
    openWhatsApp() {
      const message = `Please find attached the Purchase Invoice issued from ${this.companyName}. ${process.env.VUE_APP_CRM_URL}purchaseInvoice/${this.tenant}/${this.id}`;
      const url = `https://web.whatsapp.com/send/?text=${message}&type=phone_number`;
      window.open(url, "_blank");
    },
    getItemName(id) {
      const product = this.productList.find((x) => x.id == id);
      if (product && product.name) {
        return product.name;
      } else {
        const material = this.materials.find((x) => x.id == id);
        if (material && material.name) {
          console.log(material);
          return material.name;
        }
      }
      return "";
    },
    ...mapActions("supplierModule", ["getSupplierByIDAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("purchaseInvoiceModule", ["getPurchaseInvoicesByIDAction", "getPurchaseInvoiceDocumentListAction"]),
    ...mapActions("purchaseOrderModule", [
      "getPurchaseOrderDocumentListAction"
    ]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    downloadPDF() {
      var opt = {
        margin: [0, 0],
        filename: "quotation.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, allowTaint: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      var element = document.getElementById("invoice-preview-card");
      var elementHtml = element.outerHTML;
      html2pdf().from(elementHtml).set(opt).save();
    },
  },

  async mounted() {
    this.loadingSpinner = true; // Set to true when the component is mounted
    setTimeout(() => {
      this.loadingSpinner = false; // Set to false after 4 seconds
    }, 6000);

    await this.getProductListAction();
    await this.getRawMaterialListAction();
    await this.getPurchaseInvoicesByIDAction(this.id)
      .then(() => {
        console.log(this.purchaseinvoiceId);
        this.getSupplierByIDAction(this.purchaseinvoiceId.supplierId);
        this.getSalesPersonListAction().then(() => {
          this.SalesPersonList.forEach((element) => {
            if (element.id == this.purchaseinvoiceId.salesPersonId) {
              this.salesPersonName = element.firstName + " " + element.lastName;
            }
          });
        });
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getWarehouseListAction().then(() => {
      let warehouse = this.warehouses.filter(
        (v, i) => v.id == this.purchaseinvoiceId.warehouseId
      );
      this.warehouseName = warehouse[0].name ?? "";
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@media print {
  a[href]:after {
    content: none !important;
  }

  html,
  body {
    height: 99% !important;
  }

  // Global Styles
  .invoice-date-title {
    color: black !important;
  }

  * {
    color: black !important;
  }

  body {
    background-color: transparent !important;
    font-size: 17.5px !important;
    color: black !important;
  }

  .flatpickr-input {
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  .content-header {
    display: none !important;
  }

  .invoice-edit-input {
    border: none;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>